// third-party
import { merge } from 'lodash'

// project import
import Button from './Button'
import Dialog from './Dialog'
import Popover from './Popover'

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
    return merge(Button(theme), Popover(theme), Dialog(theme))
}
